/* eslint-disable */
import GoogleMapsLoader from '@/../../shared/src/utils/googleMaps.js'
import bowser from 'bowser'
import {promiseTimeout} from '@/../../shared/src/utils.js'
import axios, { validateApiData, validateApiGatewayData } from '@/../../shared/src/utils/axios.js'
import { getLcApiBase } from '@/../../shared/src/utils/constants.js'

export default {
  namespaced: true,
  state: {
    app: window.__APP_NAME__ ? window.__APP_NAME__ : '',
    user: window.__USER__ ? window.__USER__ : null,
    classroom: window.__CLASS_CONFIG__ ? window.__CLASS_CONFIG__ : null,
    troubleshooter: window.__TS_CONFIG__ ? window.__TS_CONFIG__ : null,
    styles: window.__STYLES__ ? window.__STYLES__ : {},
    lcApiBase: null,
    isWidget: false
  },

  getters: {

    isMobile (state, getters) {
      try {
        return state.user.browser.platform === 'mobile'
      } catch (err) {
        return false
      }
    },

    isTablet (state, getters) {
      try {
        return state.user.browser.platform === 'tablet'
      } catch (err) {
        return false
      }
    },

    classroomId (state, getters) {
      if (state.classroom) {
        return state.classroom.event.slug || state.classroom.event.id
      }
      return '9999'
    }
  },

  mutations: {

    setConfig (state, payload) {
      state = Object.assign(state, payload)
    },

    setUserData (state, payload) {
      const updatedUser = Object.assign({}, state.user, payload)
      state.user = updatedUser
    },

    setLcApiBase (state, payload) {
      state.lcApiBase = payload.lcApiBase
    },

    setLocation: function (state, payload) {
      const updatedLocation = Object.assign({}, state.user.geoLocation, payload)
      state.user.geoLocation = updatedLocation
    },

    setBrowser: function (state, payload) {
      const updatedBrowser = Object.assign({}, state.user.browser, payload)
      state.user.browser = updatedBrowser
    },

    updateWhiteboardConfig (state, payload) {
      Object.assign(state.classroom.whiteboard, payload)
    },

    setWidget (state, payload) {
      state.isWidget = payload.isWidget
    }
  },
  actions: {

    validateApiData (context, payload) {
      return validateApiData(payload)
    },

    validateApiGatewayData (context, payload) {
      return validateApiGatewayData(payload)
    },

    getConfig ({state, commit}, payload) {
      // this call is only made for widget version of classroom
      commit('setWidget', {'isWidget': true})
      const slugParam = payload.lcConf.token ? `${payload.lcConf.token}/` : ''
      return axios.post(`${state.lcApiBase}/conf/${payload.lcConf.app}/${payload.lcConf.userid}/${slugParam}`, payload.lcConf)
        .then((resp) => {
          if (payload.classConf) {
            for (const key in payload.classConf) {
              const [section, setting] = key.split('.')
              if (section === 'styles') {
                resp.data.styles[setting] = payload.classConf[key]
              } else {
                resp.data.classroom[section][setting] = payload.classConf[key]
              }
            }
          }
          commit('setConfig', {...resp.data, ...payload.lcConf})
          return {...resp.data, ...payload.lcConf}
        })
    },

    getBrowser (context, payload) {

      if (context.state.user && context.state.user.browser) {
        return Promise.resolve(context.state.user.browser)
      }

      const browserData = bowser.getParser(window.navigator.userAgent).parsedResult

      const browser = ipadCheck({
        'name': browserData.browser.name.toLowerCase(),
        'version': browserData.browser.version,
        'versionNumber': parseFloat(browserData.browser.version),
        'os': `${browserData.os.name} - ${browserData.os.version}`,
        'platform': browserData.platform.type || 'desktop'
      })
      context.commit('setBrowser', browser)
      return browser
    },

    getLocation: function (context, payload) {
      if (context.state.user.geoLocation) {
        return Promise.resolve(context.state.user.geoLocation)
      }

      return Promise.all([getGeoCoder(), getCoords()])
        .then(function ([geoCoder, coords]) {
          // Commit coords to state
          context.commit('setLocation', coords)
          return getPlaceName(geoCoder, coords)
        })
        .then(function (place) {
          // commit place to state
          const town = place.address_components.find((comp) => comp.types.includes('locality')) || {'long_name': 'Unknown'}
          const country = place.address_components.find((comp) => comp.types.includes('country')) || {'long_name': 'Unknown'}
          context.commit('setLocation', {'town': town.long_name, 'country': country.long_name})
          return context.state.user.geoLocation
        })
    },

    registerGuestDetails (context, payload) {
      context.commit('setUserData', payload)
      return context.state.user
    },

    guestSignIn ({dispatch, getters}, payload) {
      return axios.post(`/vc/guest/signin/${getters.classroomId}/`, payload)
        .then((resp) => {
          return dispatch('registerGuestDetails', resp.data)
        })
    },

    userSignIn ({dispatch, getters}, payload) {
      return axios.post(`/vc/user/signin/${getters.classroomId}/`, payload)
        .then((resp) => {
          return dispatch('registerGuestDetails', resp.data)
        })
    },

    setUserData ({commit, getters}, payload) {
      commit('setUserData', payload)
    },

    setLcApiBase({commit}, payload) {
      commit('setLcApiBase', {'lcApiBase': getLcApiBase(payload.lcConf)})
    }
  }
}

function getPlaceName (geocoder, coords) {
  const timeout = 10000
  const placeNamePromise = new Promise(function (resolve, reject) {
    geocoder.geocode({'location': coords}, function (results, status) {
      if (status === 'OK') {
        if (results.length) {
          return resolve(results[0])
        } else {
          return reject('No results')
        }
      } else {
        return reject(status)
      }
    })
  })

  return promiseTimeout(placeNamePromise, timeout)
    .catch(() => {
      throw({'code': 0, 'message': `Get Place Name from Google Maps Geocoder took more than ${timeout} ms`})
    })
}

function getGeoCoder () {
  const timeout = 10000

  const geoCoderPromise = new Promise(function (resolve, reject) {
    GoogleMapsLoader.load(function (google) {
      const geocoder = new google.maps.Geocoder()
      return resolve(geocoder)
    })
  })

  return promiseTimeout(geoCoderPromise, timeout)
    .catch(() => {
      throw({'code': 0, 'message': `Getting GeoCoder from Google Maps api took more than ${timeout} ms`})
    })
}

function getCoords () {
  const timeout = 15000

  return new Promise(function (resolve, reject) {

    function success (position) {
      return resolve({
        'lat': position.coords.latitude,
        'lng': position.coords.longitude
      })
    }
    function failure (error) {
      return reject(error)
    }
    return navigator.geolocation.getCurrentPosition(success, failure, {
      maximumAge: 60000,
      timeout: timeout,
      enableHighAccuracy: false
    })
  })

  // return coordsPromise
}

function ipadCheck (browser) {
  if (browser.os.includes('macOS') && browser.platform === 'desktop' && document.documentElement.ontouchstart === null) {
    // Is an ipad. Force change
    return Object.assign(browser, {'os': 'iOS', 'platform': 'tablet'})
  }
  return browser
}
